// extracted by mini-css-extract-plugin
export default {"btnFormHeader":"BUTTON_btnFormHeader__EDtUh"};